import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.ts';

class SuccessStory extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );

		this.init();
	}

	init() {
		const successStorySlider = this.selector.querySelector( '.success-story-slider' ) as HTMLElement;
		const sliderDuration = successStorySlider?.dataset.delaySwiper || 5000;
		const carousel = new Slider();
		if ( successStorySlider && carousel ) {
			carousel.initCarousel( successStorySlider, {
				slidesPerView: 1,
				spaceBetween: 0,
				modules: [ Pagination, Navigation, Autoplay ],
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				loop: true,
				autoplay: {
					delay: sliderDuration,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			} );
		}
	}
}

export default SuccessStory;
